import moment from "moment";

// Function to calculate state
const generateRandomString = (length) => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
};

export const state = generateRandomString(10);
const sha256 = async (plain) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return hashBuffer;
};

const base64urlencode = (str) => {
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};
export const codeVerifierData = generateRandomString(64); // Change the length as needed

export const generateCodeChallenge = async (codeVerifier) => {
  const hashed = await sha256(codeVerifier);
  return base64urlencode(hashed);
};

export const customDateFormat = (date, format = "YYYY-MM-DD") => {
  const options = {};

  if (format.includes("YYYY")) options.year = "numeric";
  if (format.includes("MM")) options.month = "2-digit";
  if (format.includes("DD")) options.day = "2-digit";
  if (format.includes("HH")) options.hour = "2-digit";
  if (format.includes("mm")) options.minute = "2-digit";
  if (format.includes("ss")) options.second = "2-digit";

  return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
};

export const toCapitalize = (str) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");
};
export const roleFormatter = (str) => {
  if (!str) return "-";
  return str
    ?.replace(/([a-z])([A-Z])/g, "$1 $2") // Adds space between lowercase and uppercase letters
    .replace(/^./, (str) => str.toUpperCase()) // Capitalizes the first letter of the string
    .split(/(?=[A-Z])/)
    .join(" ");
};

export const multipleRoleFormatter = (str) => {
  if (!str) return "-";

  return str
    .split(",") // Split on commas
    .map((s) =>
      s
        .trim()
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Optional: adds space if camelCase
        .replace(/^./, (c) => c.toUpperCase()) // Capitalize first letter
    )
    .join(", ");
};


export function generateTimestampedFilename(propertyName, extension) {
  // Get the current UTC time
  const utcDate = new Date();

  // Convert UTC to IST (UTC + 5:30)
  const istDate = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000);

  // Format the date to YYYY-MM-DD_HH-MM-SS format
  let timestamp = istDate
    .toISOString()
    .slice(0, 19)
    .replace(/:/g, "-")
    .replace("T", "_");

  // Return the formatted filename with the property name and timestamp
  return `${propertyName}_${timestamp}.${extension}`;
}

export const hourDateFormatter = (date) => {
  if (!date) return "";
  return moment(date).format("YYYY-MM-DDTHH:mm") || "";
};

const generatePasswordCustom = () => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "@!#$%^&*()-_=+[]{}|;:,.<>?";

  const all = upper + lower + numbers + special;
  const getRandomChar = (set) =>
    set.charAt(Math.floor(Math.random() * set.length));

  let result = [
    getRandomChar(upper),
    getRandomChar(lower),
    getRandomChar(numbers),
    getRandomChar(special),
  ];

  for (let i = result.length; i < 12; i++) {
    result.push(getRandomChar(all));
  }

  result = result.sort(() => 0.5 - Math.random());

  return result.join("");
};

export default generatePasswordCustom;
